import { DataStore } from './DataStore';

/**
 * Wrapper for localStorage to simplify storing and loading of JSON objects
 */
export const LocalStore = new DataStore(localStorage);
